import { UserDisplayComponentProps, UserInfo } from "@/types"
import { Table } from "@chakra-ui/react"

const UserDisplayComponent = (props: UserDisplayComponentProps) => {

    const user: UserInfo = props.user

    return (
        <Table.Root size="sm">

        <Table.Body>
                <Table.Row>
                    <Table.Cell>Name:</Table.Cell> <Table.Cell>{user.name}</Table.Cell>
                </Table.Row>
                <Table.Row><Table.Cell>Username:</Table.Cell> <Table.Cell>{user.username}</Table.Cell></Table.Row>
                <Table.Row><Table.Cell>Role:</Table.Cell> <Table.Cell>{user.role}</Table.Cell></Table.Row>
                <Table.Row><Table.Cell>Email:</Table.Cell> <Table.Cell>{user.email}</Table.Cell></Table.Row>
                <Table.Row><Table.Cell>Telegram ID:</Table.Cell> <Table.Cell>{user.telegram_id}</Table.Cell></Table.Row>
        </Table.Body>
        </Table.Root>
        

    )
}

export default UserDisplayComponent